import React from 'react';

const Home = () => {
    return (
        <div>
            <div className="home">
                <p>Search for an animal to see pictures or animals that match the search as you type.</p>
                <p>You can click a card to see addititonal information.</p>
            </div>
        </div>
    );
};

export default Home;